import { render } from "./aws_s3_form.vue?vue&type=template&id=571c1b16"
import script from "./aws_s3_form.vue?vue&type=script&lang=js"
export * from "./aws_s3_form.vue?vue&type=script&lang=js"
script.render = render

export default script